import React, { useCallback, useEffect, useState } from "react";

import { Modal, Header, Input } from "semantic-ui-react";
import WithEventWarning from "../../WithEventWarning/WithEventWarning";

const ConfirmationModal = ({ open, className, callback, iPackBoxBarcode }) => {
  const [error, setError] = useState(false);

  useEffect(() => {}, [open]);

  const _onInputKeyPress = useCallback((e) => {
    if (e.key !== "Enter") {
      return;
    }

    if (e.target.value === iPackBoxBarcode) {
      callback();
    } else {
      e.target.value = "";
      setError(true);
    }
  });

  const inputRef = React.createRef();

  useEffect(() => {
    if (inputRef && inputRef.current && inputRef.current.focus) {
      inputRef.current.focus();
    }
  });

  return (
    <Modal
      className={className}
      open={true}
      size="small"
      closeOnEscape={false}
      closeOnDimmerClick={false}
    >
      <Header>{error ? "Låda stämmer ej överens med ordern" : "Scanna lådans streckkod"}</Header>
      <Modal.Content>
        <Input
          onBlur={() => inputRef.current.focus()}
          size="huge"
          onKeyPress={(e) => _onInputKeyPress(e)}
          autoFocus
          placeholder="lådans streckkod..."
          ref={inputRef}
        ></Input>
      </Modal.Content>
    </Modal>
  );
};

export default WithEventWarning(ConfirmationModal);
